export const KM_PER_MILE = 1.609344;

export function fromKm(km, unit) {
  if (unit === "mi") return km / KM_PER_MILE;
  return km;
}

export function toKm(value, unit) {
  if (unit === "mi") return value * KM_PER_MILE;
  return value;
}

export function fmt(value, digits = 1) {
  if (value == null || isNaN(value)) return "0";
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
}

export function unitLabel(unit) {
  return unit === "mi" ? "mi" : "km";
}
